import { client } from "../../client";
import { Address } from "..";

export interface AccountInfo {
  number: string;
  name: string;
  customerName: string;
  customerNumber: string;
  paymentFrequency: string;
  parentAccountNumber: string | null;
  childAccountNumbers: string[];
  address: Address;
  startDttm: string;
  endDttm: string | null;
  status: AccountStatus;
}

export const ACCOUNT_STATUSES = [
  "Active",
  "Closed",
  "Cancelled",
  "PendingTermination",
  "Terminated",
];
export type AccountStatus = typeof ACCOUNT_STATUSES[number];

export interface AccountDetails extends AccountInfo {
  parentAccountNumber: string | null;
  childAccountNumbers: string[];
}

export const getAccount = (
  key: string,
  accountNumber: string,
): Promise<AccountDetails> => {
  return client
    .get(`accounts/${accountNumber}`)
    .then((response) => response.data);
};
